<template>
  <div class="layout">
    <Layout>
      <AppHeader :selectMenu="selectMenu" />
      <Layout>
        <Sider hide-trigger width="100" :style="{ background: '#fff' }" v-if="canShowSidBar()" class="sidebar-part">
          <Menu :active-name="siderMenu" theme="light" width="auto">
            <MenuItem name="501-1" :to="{ name: '501-running', query: { mac: this.$route.query.mac } }"
              class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/501/icon-monitor.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("k001") }}</div>
            </MenuItem>
            <MenuItem name="501-2" :to="{ name: '501-production', query: { mac: this.$route.query.mac } }"
              class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/501/icon-production.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("z016") }}</div>
            </MenuItem>
            <MenuItem name="501-3" :to="{ name: '501-control', query: { mac: this.$route.query.mac } }"
               class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/501/icon-control.png')" class="menu-icon" />
            </div>
            <div class="menu-text">手动控制</div>
            </MenuItem>
        
            <MenuItem name="501-5" :to="{ name: '501-alarm', query: { mac: this.$route.query.mac } }"
              class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/501/icon-alarm.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("k006") }}</div>
            </MenuItem>
        
            <MenuItem name="501-7" :to="{ name: '501-setting', query: { mac: this.$route.query.mac } }"
               class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/501/icon-setting.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("s336") }}</div>
            </MenuItem>
          </Menu>
        </Sider>

        <Layout :style="{ padding: '0 10px 10px' }">
          <AppBreadcrumb :sideBar="sideBar"></AppBreadcrumb>        
          <Content :style="{ padding: '10px', minHeight: '280px', background: '#fff' }">
            <slot></slot>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import AppHeader from '../AppHeader'
import { mapGetters } from 'vuex'
import AppBreadcrumb from './AppBreadcrumb'
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { postJsError } from '@/util/util.js'
export default {
  name: 'MainLayout501',
  computed: {
    ...mapGetters(['getTranslation']),
  },
  components: {
    AppHeader,   AppBreadcrumb 
  },
  props: {
    selectMenu: {
      type: String,
      default: '1-1'
    },
    sideBar: {
      type: String,
      default: ''
    },
    siderMenu: {
      type: String,
      default: '501-1'
    }
  },
  created() {    
    this.getUserInfo();   
  },
  data() {
    return {
      userInfo: {},     
    }
  },
  methods: {
    async getUserInfo() {
      let _this = this;
      let url = API_URL["userGetInfo"];
      let res = await axios.get(url)
        .catch((err) => {
          postJsError(err)
        })
      if (res && res.data && res.data.code == 200) {
        this.$nextTick(() => {
          _this.userInfo = res.data.data;
        });
      }
    },
    canShow(key) {
      if (!this.userInfo.auth) {
        return false;
      }
      let auth = this.userInfo.auth;
      if (auth === 'all') {
        return true;
      } else {
        return auth.includes(key);
      }
    },
    canShowSidBar() {
      return this.sideBar != null && this.sideBar != undefined && this.sideBar != '';
    }
  }
}
</script>
<style>
.layout .ivu-layout-header {
    height: 48px;
    line-height: 48px;
    padding: 0 0px;
}
</style>
<style scoped>

.sidebar-part>>>.ivu-layout-sider {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

.sidebar-part>>>.ivu-menu {
  width: 100px;
}

.sidebar-part>>>.ivu-menu-item {
  padding: 12px 8px;
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border-left: 5px solid transparent;
}

.sidebar-part>>>.ivu-menu-item:hover {
  background-color: rgba(28, 111, 207, 0.06);
}

.sidebar-part>>>.ivu-menu-item:hover .menu-icon {
  transform: scale(1.08);
}

.sidebar-part>>>.ivu-menu-item:hover .menu-text {
  color: #1c6fcf;
}

/* 选中状态样式 */
.sidebar-part>>>.ivu-menu-item-active,
.sidebar-part>>>.ivu-menu-item-selected {
  background-color: #d0e8ff !important;
  color: #1c6fcf !important;
  border-left: 5px solid #1c6fcf !important;
}

.sidebar-part>>>.ivu-menu-item-active .menu-text,
.sidebar-part>>>.ivu-menu-item-selected .menu-text {
  color: #1c6fcf;
  font-weight: 600;
}

.sidebar-part>>>.ivu-menu-item:last-child {
  border-bottom: none;
}

/* 垂直菜单项样式 */
.sidebar-part>>>.menu-item-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 84px;
  padding: 6px 2px;
}

.sidebar-part>>>.menu-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin-bottom: 2px;
}

.sidebar-part>>>.menu-icon {
  width: 36px;
  height: 36px;
  text-align: center;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0.7;
}

.sidebar-part>>>.ivu-menu-item:hover .menu-icon,
.sidebar-part>>>.ivu-menu-item-active .menu-icon,
.sidebar-part>>>.ivu-menu-item-selected .menu-icon {
  opacity: 1;
}

.sidebar-part>>>.menu-text {
  font-size: 11px;
  line-height: 1.1;
  text-align: center;
  word-break: break-all;
  max-width: 100%;
  padding: 0 1px;
  color: #666;
  transition: color 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
